import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export const FallbackImage = ({ src, fallbackSrc, alt = 'Image', ...props }) => {
  const [generalSrc, setGeneralSrc] = useState(src);

  useEffect(() => {
    setGeneralSrc(src);
  }, [src]);

  const onError = () => {
    setGeneralSrc(fallbackSrc);
  };

  return <img src={generalSrc} onError={onError} alt={alt} {...props} />;
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  fallbackSrc: PropTypes.string.isRequired,
};
